import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ade5086e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice-desc" }, [
  /*#__PURE__*/_createTextVNode(" 이마트 매장에 위치한 '원더플 체험존'에"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 투명 음료 페트병을 모아주세요! ")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-hint" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, " 이마트 은평점 "),
  /*#__PURE__*/_createElementVNode("div", { class: "box-desc" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
      /*#__PURE__*/_createTextVNode(" - 행사 -"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 투명 음료 페트병 수거 & 무료 참여 이벤트 (리워드 증정)"),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
      /*#__PURE__*/_createTextVNode(" 일정 : 7월 18일(목) ~ 7월 31일(수) "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 시간 : 오후 1시 ~ 오후 8시 30분 (평일/주말)"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 위치 : 8층 문화센터 계단 앞"),
      /*#__PURE__*/_createElementVNode("br")
    ])
  ])
], -1))
const _hoisted_3 = ["srcset", "media"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-tip" }, [
  /*#__PURE__*/_createTextVNode(" * 현장 리워드는 재고 소진 시 조기 종료 및 변경될 수 있습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" * 리워드 지급은 1회 한정이며 중복수령이 불가합니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" * 투명 음료 페트병은 가져오시기 전, 깨끗하게 씻은 후 라벨을 제거해주세요. ")
], -1))

import { type ComputedRef, inject } from 'vue';
import Popup from './popup.vue';

interface Props {
  modelValue: boolean;
}

interface Emits {
  (event: 'update:model-value', val: Props['modelValue']): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:model-value', val: Props['modelValue']): void;
}), expose: any, slots: any, attrs: any }) {




const images = inject<ComputedRef<Record<string, string>>>('images')!;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    "model-value": __props.modelValue,
    title: "오프라인 이벤트 안내",
    class: "notice-modal",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emits('update:model-value', $event)))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("picture", null, [
        _createElementVNode("source", {
          srcset: _unref(images)['image-notice-v3'],
          media: `(max-width: ${768}px)`
        }, null, 8, _hoisted_3),
        _createElementVNode("img", {
          class: "image",
          src: _unref(images)['image-notice-v3-pc']
        }, null, 8, _hoisted_4)
      ]),
      _hoisted_5
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})